import { render } from "./soins_details_modal.vue?vue&type=template&id=4192ee21"
import script from "./soins_details_modal.vue?vue&type=script&lang=js"
export * from "./soins_details_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__